import { z } from 'zod';

/**
 * Paging object returned by legacy `/search/*` style list endpoints.
 */
export const searchApiPagingFromHttp$ = z.object({
  total: z.number(),
  page: z.number(),
  count_per_page: z.number()
});

/**
 * Factory: `{ results: T[], paging?: … }` as returned by many search APIs.
 * Use with a concrete item schema when each row should be validated here.
 */
export function searchApiListEnvelopeFromHttp$<T extends z.ZodTypeAny>(
  itemSchema: T
) {
  return z.object({
    results: z.array(itemSchema),
    paging: searchApiPagingFromHttp$.optional()
  });
}

/**
 * Same envelope as `searchApiListEnvelopeFromHttp$` with `unknown[]` results,
 * for endpoints that run per-row validation afterward (e.g. row-level Zod).
 */
export const searchApiListEnvelopeUnknownResultsFromHttp$ = z.object({
  results: z.array(z.unknown()).default([]),
  paging: searchApiPagingFromHttp$.optional()
});
